import styled from 'styled-components'

import { ButtonAsync, muiRipple } from '@subaio/components'

import { helpers } from 'styles'

export const ButtonLink = styled(ButtonAsync)`
	color: ${helpers.color.action};
	background-color: transparent;
	font: ${helpers.fonts.button};
	border-radius: 4px;
	height: 36px;
	padding: ${helpers.spacing.small} ${helpers.spacing.large};
	transition: color 0.2s, background-color 0.2s;
	isolation: isolate;

	&:is(:focus-visible, :hover) {
		background-color: transparent;
	}

	&:focus-visible {
		outline: 2px solid ${helpers.color.link};
		outline-offset: -2px;
	}

	&:disabled {
		color: ${helpers.color.actionDisabledLabel};
	}

	${muiRipple()};

	&:not(:disabled) {
		&:is(:focus-visible, :hover):before {
			opacity: 0;
		}
	}
`
